module.exports = flarum.core.compat['utils/KeyboardNavigatable'];